import { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Divider, Flex, Image } from '@chakra-ui/react';

import goToMobile from 'assets/brand/selfie@2x.png';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import SunshineCard from 'components/_core/SunshineCard';
import Text from 'components/_core/Text';
import BackButton from 'components/BackButton';
import * as ContentLayout from 'layouts/ContentLayout';

import locales from './locales';

const PaymentCardRenewal: FC = () => {
  return (
    <ContentLayout.Root>
      <ContentLayout.Body>
        <Box marginBottom="space-24">
          <BackButton to="/" />
        </Box>
        <SunshineCard padding="space-0" width={600}>
          <SunshineCard.Content paddingX="space-32">
            <Flex
              alignItems="center"
              flexDirection="column"
              paddingY="space-40"
              textAlign="center"
              width="100%"
            >
              <Image
                alt="mobile application"
                height={180}
                marginBottom="space-24"
                role="presentation"
                src={goToMobile}
              />
              <Heading marginBottom="space-16" size="lg">
                {locales.title}
              </Heading>
              <Text>{locales.descriptionLineOne}</Text>
              <Text>{locales.descriptionLineTwo}</Text>
            </Flex>
          </SunshineCard.Content>

          <Divider />

          <SunshineCard.Content paddingX="144px" paddingY="space-24">
            <Button
              as={RouterLink}
              icon="link"
              textAlign="center"
              to="/"
              variant="tertiary"
              width="100%"
            >
              {locales.goBackHome}
            </Button>
          </SunshineCard.Content>
        </SunshineCard>
      </ContentLayout.Body>
    </ContentLayout.Root>
  );
};

export default PaymentCardRenewal;
